/**
 * Tracks consecutive hits within a time window and provides combo bonuses.
 */
export class ComboSystem {
  constructor() {
    this.count = 0;
    this.timer = 0;
    this.comboWindow = 1.5; // seconds to land next hit before combo resets
    this.maxCombo = 0; // track highest combo in current run
  }

  /**
   * Register a hit. Increments combo and resets the timer.
   * @returns {{ count: number, bonusDamage: number, bonusXP: number }}
   */
  registerHit() {
    this.count++;
    this.timer = this.comboWindow;

    if (this.count > this.maxCombo) {
      this.maxCombo = this.count;
    }

    return {
      count: this.count,
      bonusDamage: this._getDamageBonus(),
      bonusXP: this._getXPBonus(),
    };
  }

  /**
   * Bonus damage multiplier based on combo count.
   * +5% per combo hit, capped at +50%.
   */
  _getDamageBonus() {
    return Math.min(0.5, (this.count - 1) * 0.05);
  }

  /**
   * Bonus XP for combo thresholds.
   * +1 XP per 5 combo hits.
   */
  _getXPBonus() {
    return Math.floor(this.count / 5);
  }

  /**
   * @param {number} dt - Delta time in seconds
   */
  update(dt) {
    if (this.count > 0 && this.timer > 0) {
      this.timer -= dt;
      if (this.timer <= 0) {
        this.count = 0;
        this.timer = 0;
      }
    }
  }

  reset() {
    this.count = 0;
    this.timer = 0;
  }
}
